/**
 * SaldoAFavorBanner — muestra el saldo a favor de la casa cuando es > 0.
 *
 * El saldo a favor es plata que el vecino pagó de más (sobrante tras cubrir
 * sus cuotas). Se muestra en Inicio y en Mi cuenta para que el vecino lo
 * vea. Si el monto es 0 (el caso normal), no renderiza nada.
 *
 * El dato viene de `EstadoCuentaResponse.saldo_a_favor_actual`.
 */
import { formatCLP } from '../../lib/format';

interface SaldoAFavorBannerProps {
  monto: number;
  className?: string;
}

export function SaldoAFavorBanner({
  monto,
  className = '',
}: SaldoAFavorBannerProps) {
  if (!monto || monto <= 0) return null;
  return (
    <div
      className={`bg-state-success/15 border-l-4 border-state-success rounded-sm p-3 text-sm text-text-primary ${className}`.trim()}
    >
      Tienes <strong>{formatCLP(monto)}</strong> a favor. Se aplicará a tus
      próximas cuotas.
    </div>
  );
}
